import { render, staticRenderFns } from "./PublicCourseItem.vue?vue&type=template&id=c9c9a004&scoped=true&"
import script from "./PublicCourseItem.vue?vue&type=script&lang=js&"
export * from "./PublicCourseItem.vue?vue&type=script&lang=js&"
import style0 from "./PublicCourseItem.vue?vue&type=style&index=0&id=c9c9a004&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c9a004",
  null
  
)

export default component.exports